import { useCallback } from 'react';
import { useDispatch } from 'store';
import { openSnackbar } from 'store/slices/snackbar';
import { useIntl } from 'react-intl';

//type Severity = 'success' | 'info' | 'warning' | 'error';

export const Severity = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
} as const;

export type Severity = typeof Severity[keyof typeof Severity];

interface NotifyOptions {
  message: string;
  values?: Record<string, any>;
  severity?: Severity;
  usei18n?: boolean; // Optional flag to indicate if messageId should be treated as an i18n key
}

export const useINotify = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const notify = useCallback(
    ({ message, values, severity = Severity.INFO, usei18n = true }: NotifyOptions) => {
      let _message = message;
      if (usei18n) {
        _message = intl.formatMessage({ id: message }, values);
      }
      dispatch(
        openSnackbar({
          open: true,
          message: _message,
          severity,
          variant: 'alert',
          alert: {
            color: severity
          },
          close: false
        })
      );
    },
    [dispatch, intl]
  );

  return notify;
};


export const useIMessage = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const message = useCallback(
    ({ message }: NotifyOptions) => {
      let _message = message;
      
      dispatch(
        openSnackbar({
          open: true,
          message: _message,
          severity: Severity.INFO,
          variant: 'alert',
          alert: {
            color: Severity.INFO
          },
          close: false
        })
      );
    },
    [dispatch, intl]
  );

  return message;
};